import { styled } from '@mui/material'

export const FilterPillsWrapper = styled('div')(({ theme }) => ({ // eslint-disable-line
  marginBottom: '25px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '20px',
  },
}))
